// import {detectPrivateMode} from "./utils";

let localStorageAvailable = null;

export function detectPrivatedModeBrowser() {
  return new Promise(resolve => {
    // detectPrivateMode(isPrivated => {
    //   localStorageAvailable = !!isPrivated;
    //   // console.log("detectPrivatedModeBrowser", localStorageAvailable);
    //   // alert(localStorageAvailable ? "private mode" : "NOT private mode");
    //   resolve();
    // });
    const mod = 'test_local_storage';
    try {
      localStorage.setItem(mod, mod);
      localStorage.removeItem(mod);
      localStorageAvailable = true;
    } catch (e) {
      localStorageAvailable = false;
    }
    resolve();
  });
}

export function storageCachingSupported() {
  try {
    window.sessionStorage.setItem('_testSession_', '_testSession_');
    window.sessionStorage.removeItem('_testSession_');
  } catch (e) {
    try {
      window.localStorage.setItem('_testSession_', '_testSession_');
      window.localStorage.removeItem('_testSession_');
    } catch (e) {
      return false;
    }

    return true;
  }
  return true;
}

detectPrivatedModeBrowser().then(res => res);

export function getKey(key) {
  if (localStorageAvailable) {
    return window.localStorage.getItem(key);
  }
  if (window && window.sessionStorage) {
    return window.sessionStorage.getItem(key);
  }
  return null;
}

export function setKey(key, value) {
  if (localStorageAvailable) {
    window.localStorage.setItem(key, value);
  } else if (window && window.sessionStorage) {
    window.sessionStorage.setItem(key, value);
  }
}

export function deleteKey(key) {
  if (localStorageAvailable) {
    window.localStorage.removeItem(key);
  } else if (window && window.sessionStorage) {
    window.sessionStorage.removeItem(key);
  }
}
